// FormatDate.js
const FormatDate = (dateString) => {
  if (!dateString) return "";
  const date = new Date(dateString);

  const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
                  "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

  return `${date.getUTCDate()} ${months[date.getUTCMonth()]} ${String(date.getUTCFullYear()).slice(-2)}`;
};

export default FormatDate;